import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tile = _resolveComponent("tile")!
  const _component_edge = _resolveComponent("edge")!
  const _component_corner = _resolveComponent("corner")!

  return (_openBlock(), _createElementBlock("div", {
    class: "board",
    style: _normalizeStyle(_ctx.boardStyle)
  }, [
    _createElementVNode("div", {
      class: "board-background",
      style: _normalizeStyle(_ctx.boardBackgroundStyle)
    }, null, 4),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiles, (tile) => {
      return (_openBlock(), _createBlock(_component_tile, {
        key: `tile:${tile.id}`,
        tile: tile,
        style: _normalizeStyle(tile.style)
      }, null, 8, ["tile", "style"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.edges, (edge) => {
      return (_openBlock(), _createBlock(_component_edge, {
        key: `edge:${edge.corners[0]}:${edge.corners[1]}`,
        corners: edge.corners,
        road: edge.road,
        style: _normalizeStyle(edge.style),
        direction: edge.direction
      }, null, 8, ["corners", "road", "style", "direction"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.corners, (corner) => {
      return (_openBlock(), _createBlock(_component_corner, {
        key: `corner:${corner.id}`,
        corner: corner,
        style: _normalizeStyle(corner.style)
      }, null, 8, ["corner", "style"]))
    }), 128))
  ], 4))
}